import { render, staticRenderFns } from "./myNews.vue?vue&type=template&id=78082a09&scoped=true&"
import script from "./myNews.vue?vue&type=script&lang=js&"
export * from "./myNews.vue?vue&type=script&lang=js&"
import style0 from "./myNews.vue?vue&type=style&index=0&id=78082a09&prod&lang=scss&"
import style1 from "./myNews.vue?vue&type=style&index=1&id=78082a09&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78082a09",
  null
  
)

export default component.exports